import React from "react";
import "./ProjectTile.css";
import ClickableTile from "../clickableTile/ClickableTile";

export default function ProjectTile({ projectTitle, languages, link }) {
  return (
    <ClickableTile
      content={
        <>
          <h2 className="project-tile-title"> {projectTitle + "↗"} </h2>
          <div className="language-bar">
            {Object.entries(languages).map(([lang, percent]) => (
              <div
                key={lang}
                className="lang-segment"
                style={{
                  width: `${percent}%`,
                  backgroundColor: getColorForLanguage(lang) || "#ccc",
                }}
                title={`${lang}: ${percent}%`}
              />
            ))}
          </div>
          <ul className="lang-list">
            {Object.entries(languages).map(([lang, percent]) => (
              <li key={lang}>
                <span
                  className="lang-dot"
                  style={{
                    backgroundColor: getColorForLanguage(lang) || "#ccc",
                  }}
                />
                {lang} ({percent}%)
              </li>
            ))}
          </ul>
        </>
      }
      link={link}
    />
  );
}

function getColorForLanguage(language) {
  const colors = {
    JavaScript: "#f1e05a",
    HTML: "#e34c26",
    CSS: "#563d7c",
    Python: "#3572A5",
    TypeScript: "#2b7489",
    C: "#555555",
    "C++": "#f34b7d",
    Java: "#b07219",
    PHP: "#4F5D95",
    Ruby: "#701516",
    Swift: "#ffac45",
    Rust: "#dea584",
    Go: "#00ADD8",
    Kotlin: "#A97BFF",
    Shell: "#89e051",
    Dockerfile: "#384d54",
  };
  return colors[language] || "#999999";
}
